import { Outlet, useNavigate } from "@tanstack/react-router"
import {
  Sidebar,
  SIDEBAR_STORAGE_NAME,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar.tsx"
import { AppSidebar } from "@/components/AppSidebar.tsx"
import { TooltipProvider } from "@/components/ui/tooltip.tsx"
import { NavUser } from "@/components/NavUser.tsx"
import { Separator } from "@/components/ui/separator.tsx"
import { usePageTitle } from "@/contexts/PageTitleContext.tsx"
import { useIsMobile } from "@/hooks/use-mobile.ts"
import LogoIcon from "@/assets/logo-icon.svg"
import { CreatePitchButton } from "@/components/CreatePitchButton.tsx"
import { TOKEN_NAME } from "@/api/client.ts"
import { useUser } from "@/contexts/UserContext.tsx"
import "../i18n"
import { useEffect } from "react"
import { trackCustomerPage } from "@/lib/customer-io.ts"

export function ProtectedLayout() {
  const { title } = usePageTitle()
  const navigate = useNavigate()
  const isMobile = useIsMobile()
  const { locale } = useUser()

  const isAuthenticated = !!localStorage.getItem(TOKEN_NAME)
  const openState = !(localStorage.getItem(SIDEBAR_STORAGE_NAME) === "false")

  if (!isAuthenticated) {
    navigate({
      to: "/login",
    })
  }

  useEffect(() => {
    trackCustomerPage()
  }, [location.pathname])

  return (
    <div
      dir={locale === "ar" ? "rtl" : "ltr"}
      className={locale === "ar" ? "font-arabic" : ""}
    >
      <TooltipProvider>
        <SidebarProvider defaultOpen={openState}>
          <AppSidebar className="m-0" />
          <div className="h-full w-full">
            <header className="fixed right-0 left-0 z-2 flex items-center justify-between border-b bg-background pr-1">
              <div className="container flex flex-row items-center px-4 py-4">
                {!isMobile && (
                  <Sidebar
                    collapsible="icon"
                    dir={locale === "ar" ? "rtl" : "ltr"}
                    side={locale === "ar" ? "right" : "left"}
                  />
                )}
                {isMobile && <img width="24" src={LogoIcon} alt="" />}
                <SidebarTrigger />
                <Separator className="mr-2 ml-2" orientation="vertical" />
                <h1 className="overflow-x-hidden leading-7 font-semibold text-nowrap text-ellipsis">
                  {title}
                </h1>
              </div>
              <div className="relative flex items-center gap-2">
                <div className="md:hidden">
                  <CreatePitchButton withText={false} />
                </div>
                <NavUser />
              </div>
            </header>

            <main className="h-dvh pt-13" dir={locale === "ar" ? "rtl" : "ltr"}>
              <div className="box-border flex h-full w-full flex-col p-4 pt-6 pb-6">
                <Outlet />
              </div>
            </main>
          </div>
        </SidebarProvider>
      </TooltipProvider>
    </div>
  )
}
